import { render } from "./MenuPmModuleOverview.vue?vue&type=template&id=5d859817&scoped=true"
import script from "./MenuPmModuleOverview.vue?vue&type=script&lang=js"
export * from "./MenuPmModuleOverview.vue?vue&type=script&lang=js"

import "./MenuPmModuleOverview.vue?vue&type=style&index=0&id=5d859817&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d859817"]])

export default __exports__